function SvgFileLock(props, { color = "#007539", width = 20, height = 20 }) {
  const { color: iconColor, ...restProps } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M12.082 1.66602H4.9987C4.55667 1.66602 4.13275 1.84161 3.82019 2.15417C3.50763 2.46673 3.33203 2.89065 3.33203 3.33268V16.666C3.33203 17.108 3.50763 17.532 3.82019 17.8445C4.13275 18.1571 4.55667 18.3327 4.9987 18.3327H14.9987C15.4407 18.3327 15.8646 18.1571 16.1772 17.8445C16.4898 17.532 16.6654 17.108 16.6654 16.666V6.24935L12.082 1.66602Z"
        stroke={iconColor || color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5013 10H7.5013C7.04106 10 6.66797 10.3731 6.66797 10.8333V14.1667C6.66797 14.6269 7.04106 15 7.5013 15H12.5013C12.9615 15 13.3346 14.6269 13.3346 14.1667V10.8333C13.3346 10.3731 12.9615 10 12.5013 10Z"
        stroke={iconColor || color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 10.0007V8.33398C12.5 7.67094 12.2366 7.03506 11.7678 6.56622C11.2989 6.09738 10.663 5.83398 10 5.83398C9.33696 5.83398 8.70107 6.09738 8.23223 6.56622C7.76339 7.03506 7.5 7.67094 7.5 8.33398V10.0007"
        stroke={iconColor || color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgFileLock;
